import { DATE_FORMAT,TIME_FORMAT } from "helpers/common";
import Badge from "react-bootstrap/Badge";
import React from "react";
import { Link } from "react-router-dom";
const STATUS = {
  active: "Active",
  inactive: "Inactive",
  blocked: "Blocked",
  deleted: "Deleted",
  pending: "Pending",
};
const PatientColumns = ({
  onCliclNavigate,
  handleViewUser,
  handleEdithandler,
  currentPage,
  pageSize,
  deleteHandler,
  handleUserStatus,
  handleViewUserPatient
}) => {
  return [
    {
      dataField: "SrNo",
      text: "SrNo",
      formatter: (cell, row, rowIndex) => (
        <span className="text-capitalize cursor-pointer">
         {row?.recordid}
        </span>
      ),
    },

    {
      dataField: "first_name",
      text: "Patient Name",
      formatter: (_, row) => (
        <span className="text-capitalize cursor-pointer">{row?.full_name || "--"}</span>
      ),
    },
    {
      dataField: "email1",
      text: "Email",
      formatter: (_, row) => (
        <span className="text-capitalize cursor-pointer">
          {row?.email || "--"}
        </span>
      ),
    },
    {
      dataField: "phone_no",
      text: "Phone No",
      formatter: (_, row) => (
        <span className="text-capitalize cursor-pointer">
          {row?.phone_no && row?.country_code
            ? `${row.country_code} ${row.phone_no}`
            : "--"}
        </span>
      ),
    },
        {
          text: "Appointment Date",
          dataField: "createdAt",
          formatter: (_, row) => row?.appointment_date || "--",
        },
         {
          text: "Appointment Time",
          dataField: "createdAt",
          formatter: (_, row) => row?.appointment_time || "--",
        },
         {
      text: "Status",
      dataField: "status",
      formatter: (_, row) => (
        <span>
          {row?.status && row.status == "5" ? (
            <span className="text  " style={{ background: "", color: "#227fd5" }}>
        Done
      </span>
          ) : (
            <span className="text  " style={{ background: "", color: "#227fd5" }}>
        -
      </span>
          )}
        </span>
      ),
    },
    // {
    //   text: "Appointment Date",
    //   dataField: "createdAt",
    //   formatter: (_, row) => DATE_FORMAT(row?.createdAt),
    // },
    // {
    //   text: "Status",
    //   dataField: "status",
    //   formatter: (_, row) => (
    //     <span>
    //       {row?.status && row.status == "1" ? (
    //         <button
    //           className="fas fa-toggle-on"
    //           style={{
    //             fontSize: "20px",
    //             color: "green",
    //             backgroundColor: "#fff",
    //             border: "none",
    //           }}
    //           title="Active"
    //           onClick={() => handleUserStatus(row, "0")}
    //         ></button>
    //       ) : (
    //         <button
    //           className="fas fa-toggle-off"
    //           style={{
    //             fontSize: "20px",
    //             color: "red",
    //             backgroundColor: "#fff",
    //             border: "none",
    //           }}
    //           title="Inactive"
    //           onClick={() => handleUserStatus(row, "1")}
    //         ></button>
    //       )}
    //     </span>
    //   ),
    // },
    {
      text: "Action",
      dataField: "Action",
      formatter: (_, row) => (
        <>
         <button
          className="p-2 shadow rounded-2"
          style={{
            fontSize: "12px",
            color: "white",
            backgroundColor: "#227fd5",
            border: "none",
          }}
          title="Record View"
          onClick={() => handleViewUserPatient(row)}
        >
          
          Meeting Record
        </button>                     
        </>
      ),
    },
  ];
};

export default PatientColumns;
